import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-dustin-white',
  imports: [Link, RouterLink],
  templateUrl: './dustin-white.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dustin-white.scss',
})
export class DustinWhite {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Dustin White`);
    this.dynamicTitle.description(`Dustin White is a Christian apologist who utilizes bias priming to inflate his own lack of authority. He often contradicts himself, unable to recall what he has written previously.`);
  }
}
